import { render, staticRenderFns } from "./order.vue?vue&type=template&id=73b017b0&scoped=true&"
import script from "./order.js?vue&type=script&lang=js&"
export * from "./order.js?vue&type=script&lang=js&"
import style0 from "./order.vue?vue&type=style&index=0&id=73b017b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b017b0",
  null
  
)

export default component.exports